import { Type } from "class-transformer";
import { AbstractJSONModel } from "./master-model";

export enum eStatus {
  Alle = -1,
  Ubehandlet = 100, // Hedder 0 i back-end, men select kan ikke finde ud af at haandtere item med id 0, deres tekst bliver ikke vist.
  Godkendt = 1,
  Afvist = 2,
  Nulstillet = 3
}

export interface IChangerequest {
  id: number;
  date: Date;
  employee_id: number;
  duty_id?: number;
  start_time: number;
  start_time_org?: number;
  end_time: number;
  end_time_org?: number;
  bell_time_id?: number;
  bell_time_id_org?: number;
  school_class_id?: number;
  school_class_id_org?: number;
  school_time_schedule_id?: number;
  conversion_factor?: number;
  conversion_factor_org?: number;
  created_at: Date;
  updated_at: Date;
  state: number;
  target: number;
  purpose_is_for_deletion_of_duty: boolean;
  comment: string;
}

export class Changerequest extends AbstractJSONModel implements IChangerequest {
  public id = -1;
  public name = "";
  public employee_id = -1;
  @Type(() => Date)
  public created_at: Date = new Date();
  @Type(() => Date)
  public updated_at: Date = new Date();
  @Type(() => Date)
  date: Date = new Date();
  duty_id?: number | undefined;
  start_time = 0;
  start_time_org?: number | undefined;
  end_time = 0;
  end_time_org?: number | undefined;
  bell_time_id?: number | undefined;
  bell_time_id_org?: number | undefined;
  school_class_id?: number | undefined;
  school_class_id_org?: number | undefined;
  school_time_schedule_id?: number | undefined;
  conversion_factor?: number | undefined;
  conversion_factor_org?: number | undefined;
  state = -1;
  target = -1;
  purpose_is_for_deletion_of_duty = false;
  comment = "";

  pending() {
    return this.state === eStatus.Ubehandlet || this.state === 0;
  }
  approved() {
    return this.state === eStatus.Godkendt;
  }
  cleared() {
    return this.state === eStatus.Nulstillet;
  }

  rejected() {
    return this.state === eStatus.Afvist;
  }

  public duration(): number {
    const unconverted_duration = this.end_time - this.start_time;
    return unconverted_duration * (this.conversion_factor ? this.conversion_factor : 1);
  }

  equals(other: IChangerequest): boolean {
    return other.id === this.id;
  }
}
